export default class BaseStore {
  namespaced = true;
}
